import { CheckIcon } from "@heroicons/react/20/solid";
import React from "react";

const features = [
  {
    name: "Lifetime updates",
    description:
      "Once you buy the kit, you get access to free updates and additions, forever.",
  },
  {
    name: "MV3 Support",
    description:
      "All basic, React, Vue, and example extensions are built on the latest Manifest V3.",
  },
  {
    name: "TypeScript support",
    description:
      "React (and Vue soon) templates come with TypeScript variants and support out-of-the-box.",
  },
  {
    name: "Developer productivity tools",
    description:
      "Webpack-supported templates (Vue, React) come with loads of developer tooling such as auto-extension refresh during development.",
  },
  {
    name: "Unopinionated templates",
    description:
      "All templates are unopinionated (minimal styles, etc) so you can quickly grab your chosen template and get started right away.",
  },
  {
    name: "Private Discord community",
    description:
      "Members get access to the Discord community to show off your current extension projects, ask questions, share resources, and more.",
  },
];

const Features = () => {
  return (
    <div className="bg-slate-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <div>
            <h2 className="text-lg font-semibold leading-8 tracking-tight text-emerald-600">
              Features
            </h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Everything you need for extension development
            </p>
            <p className="mt-6 text-base leading-7 text-slate-600">
              ExtensionKit comes with all the tools you need to build your next
              Chrome Extension project faster than ever
            </p>
          </div>
          <dl className="col-span-2 grid grid-cols-1 gap-x-8 gap-y-10 text-base leading-7 text-slate-600 sm:grid-cols-2 lg:gap-y-16">
            {features.map((feature) => (
              <div key={feature.name} className="relative pl-9">
                <dt className="font-semibold text-slate-900">
                  <CheckIcon
                    className="absolute top-1 left-0 h-5 w-5 text-emerald-500"
                    aria-hidden="true"
                  />
                  {feature.name}
                </dt>
                <dd className="mt-2">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default Features;
